import React, { Fragment, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import Styles from "../DetailParcelle.scss";

const DataParcelle = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [asData, setAsData] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        props.keypar ? fetchData() : null;
    }, [props.detailKeyPar]);

    useEffect(() => {
        items.length > 0 ? setAsData(true) : setAsData(false);
    }, [items]);

    const fetchData = () => {
        setIsLoading(true);
        const params = {
            key_parcelles: [props.keypar],
        };
        axios
            .post("/Api/geodata/vmap/parcelle", params)
            .then((result) => {
                setItems(result.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div id={"majic-parcelle"}>
            {asData ? (
                <Fragment>
                    <div
                        className={
                            "section section-data card ueThemeBackground ueColorBase border-0"
                        }
                    >
                        <div className="card-body section-body">
                            <div
                                className="ue-detail-parcelle-section-title"
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "13px",
                                    paddingBottom: "5px",
                                }}
                            >
                                FICHE PARCELLAIRE {" "}
                                {props.detailKeyPar
                                    ? props.detailKeyPar.substring(8)
                                    : null}
                            </div>
                            <table
                                className="table table-condensed ue-table-data"
                                style={{ width: "100%", fontSize: "0.65rem" }}
                            >
                                <tbody>
                                    <tr>
                                        <td>Commune : </td>
                                        <td>
                                            {items[0]?.commune}(
                                            {items[0]?.id_insee})
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Surface géographique : </td>
                                        <td>
                                            <NumberFormat
                                                value={
                                                    items[0]
                                                        ?.surface_geographique
                                                }
                                                displayType={"text"}
                                                thousandSeparator={" "}
                                            />
                                            m<sup>2</sup>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Contenance : </td>
                                        <td>
                                            <NumberFormat
                                                value={
                                                    items[0]?.surface_cadastrale
                                                }
                                                displayType={"text"}
                                                thousandSeparator={" "}
                                            />{" "}
                                            m<sup>2</sup>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Adresse DGFIP : </td>
                                        <td>{items[0]?.adresse} </td>
                                    </tr>
                                    <tr>
                                        <td>Batie : </td>
                                        <td>{items[0]?.parcelle_batie}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Fragment>
            ) : isLoading ? (
                <div className="text-center my-2">
                    <Spinner animation="border" size={"sm"} />
                </div>
            ) : (
                <div></div>
            )}
            <div style={{ height: "2rem" }}></div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        detailKeyPar: state.LeftPanelReducer.detailKeyPar,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchTProps)(DataParcelle);
